import React, {useContext} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import useStyles from "../styles";
import Card from "@material-ui/core/Card";
import  Rating  from "@material-ui/lab/Rating";
import {
  API_DOMAIN_B2B2C,
  API_SECTION_ACCOUNTS,
  B2B2C_API_VERSION,
  API_ENDPOINT_TA_CUSTOMER_FEEDBACK,
  API_RESPONSE_UNAUTHORIZED_STATUS,
} from "../../../../Constants";
import {
  WebContext,
  postPrivateApi,
} from "../../../../Utility";
import { useTheme } from "@material-ui/core/styles";
const SubmitFeedback = ({
  leadPax = "",
  travelDate = "",
  destination = "",
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const {
    setViewSnackbar,
    deskTopView = false,
    setOpenDailogMain,
  } = useContext(WebContext);
  const getDateInFormat = () => {
    let travelDateNew = new Date(travelDate);
    let dateOfTravel = `${travelDateNew.getFullYear()}-${
      travelDateNew.getMonth() + 1 < 10
        ? `0${travelDateNew.getMonth() + 1}`
        : travelDateNew.getMonth() + 1
    }-${
      travelDateNew.getDate() < 10
        ? `0${travelDateNew.getDate()}`
        : travelDateNew.getDate()
    }`;
    return dateOfTravel;
  };

  const handleFeedback = async () => {
    let redirectLink = "";
    let dateOfTravel = getDateInFormat();
    const postData = {
      customer_name: leadPax,
      date_of_travel: dateOfTravel,
      destination: destination,
    };
    const baseUrl = `${API_DOMAIN_B2B2C}${API_SECTION_ACCOUNTS}${B2B2C_API_VERSION}${API_ENDPOINT_TA_CUSTOMER_FEEDBACK}`;
    const {
      data = [],
      status,
    } = await postPrivateApi(baseUrl, postData, {}, "post", true);
    if (status == 400) {
      return;
    } else if (status == API_RESPONSE_UNAUTHORIZED_STATUS) {
      setOpenDailogMain(true);
    }
    if (status >= 200 && status < 300) {
      let { link = "" } = data;
      redirectLink = link;
    } else {
      setViewSnackbar({ message: "Something went wrong!", type: "error" });
    }
    await window.open(redirectLink);
  };

  return (
    <Box mt={2} mb={!deskTopView && 3}>
      <Card className={classes.rightCards} onClick={() => handleFeedback()}>
        <Box display="flex" justifyContent="space-between" width="100%">
          <Typography
            variant="subtitle1"
            style={{ color: theme?.agentTheme?.card?.foreground }}
          >
            Submit Feedback
          </Typography>
          <Rating
            readOnly={true}
            value={0}
            color={theme.agentTheme.secondary.main}
            className={classes.starRating}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default SubmitFeedback;
